import {createActionCreators, ImmerReducer} from 'immer-reducer'
import defaultSpeedBumpState, {SpeedBumpStateType, SpeedBumpType} from './state'
import {Action} from '@reduxjs/toolkit'
import {ThunkType} from 'commonTypes'
import {call, put, race, take, takeLatest} from 'redux-saga/effects'
import {
  applyBulkEditForAllUrlsSpeedBumpDefaults,
  applyGenericConfirmSpeedBumpDefaults,
  applyGenericSuccessSpeedBumpDefaults,
  applyRescheduleFailedJobsSpeedBumpDefaults,
} from './speedBump.types.duck'
import {handleError} from 'helpers/common'

class SpeedBump extends ImmerReducer<SpeedBumpStateType> {
  speedBumpShown() {
    this.draftState.show = true
  }
  speedBumpHidden() {
    this.draftState.show = false
  }
  // for new speedBump type create a new thunk in speedBump.types.duck.ts and specify how speedBump properties are applied using this method
  speedBumpStateApplied(speedBumpStateData: SpeedBumpStateType) {
    this.draftState = {
      ...defaultSpeedBumpState,
      ...speedBumpStateData,
    }
  }
  speedBumpStateReset() {
    this.draftState = defaultSpeedBumpState
  }
  testActionApplied(arg) {
    console.log('firing test action', arg)
  }
  // purely signal actions, no store mutation
  withSpeedBump() {}
  confirmSpeedBump() {}
  cancelSpeedBump() {}
}

export const speedBumpAC = createActionCreators(SpeedBump)

const withSpeedBump = speedBumpAC.withSpeedBump.type

export const actionWithSpeedBump = (intendedAction: Action, speedBumpType: SpeedBumpType) => ({
  type: withSpeedBump, payload: {intendedAction, speedBumpType},
})

export const thunkWithSpeedBump = (thunk: ThunkType, speedBumpType: SpeedBumpType, ...args) => {
  return {
    type: withSpeedBump, payload: {thunk, speedBumpType, args},
  }
}

export const callbackWithSpeedBump = (callback, speedBumpType: SpeedBumpType) => ({
  type: withSpeedBump, payload: {callback, speedBumpType},
})

export const triggerSpeedBump = function*  (action) {
  const {payload: {thunk, intendedAction, callback, speedBumpType, args}} = action
  try {
    yield call(applySpeedBumpType, speedBumpType)
    yield put(speedBumpAC.speedBumpShown())
    const {confirmed, canceled} = yield race({
      confirmed: take(speedBumpAC.confirmSpeedBump.type),
      canceled: take(speedBumpAC.cancelSpeedBump.type),
    })
    yield put(speedBumpAC.speedBumpHidden())
    if (confirmed) {
      if (thunk) {
        yield put(thunk(...args))
      } else if (intendedAction) {
        yield put(intendedAction)
      } else if (callback) {
        callback()
      }
    } else if (canceled) {
      if(__WEBPACK_ISDEV__) {
        console.info('action cancelled')
      }
    }
    yield put(speedBumpAC.speedBumpStateReset())
  } catch (err) {
    handleError('SPEED BUMP / Speed Bump Saga error', err)
  }
}

export const applySpeedBumpType = function* (speedBumpType: SpeedBumpType) {
  switch(speedBumpType) {
  case SpeedBumpType.genericConfirm:
    return yield put(applyGenericConfirmSpeedBumpDefaults())
  case SpeedBumpType.genericSuccess:
    return yield put(applyGenericSuccessSpeedBumpDefaults())
  case SpeedBumpType.rescheduleFailedJobs:
    return yield put (applyRescheduleFailedJobsSpeedBumpDefaults())
  case SpeedBumpType.bulkEditForAllUrls:
    return yield put (applyBulkEditForAllUrlsSpeedBumpDefaults())
  }
}

export const watchWithSpeedBump = function* () {
  yield takeLatest(withSpeedBump, triggerSpeedBump)
}

export default SpeedBump
